import type { Group } from "@/group";
import { showSnackbar } from "@/snackbar/snackbar";
import { SNACKBAR_TIMEOUT } from "../constants/aiConstants";
import { processSelectedWidgets } from "./processSelectedWidgets";

export function getWidgetsForAi(widgets: Group[]) {
    const { widgetUIDs } = processSelectedWidgets(widgets, "create");

    if (!widgetUIDs.length) {
        showSnackbar("Недостаточно текста для анализа", { duration: SNACKBAR_TIMEOUT });
    }

    return widgetUIDs;
}
